// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import Link from "next/link";
import * as CityContext$PorterinFeature from "../../contexts/city-context/CityContext.mjs";
import * as HomeStoreEn$PorterinFeature from "../../containers/home/domain/store/HomeStoreEn.mjs";
import * as PageviewStore$PorterinFeature from "../../containers/fare-estimate-v1/domain/store/PageviewStore.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../shared/core/helpers/PublishEventsHelper.mjs";

function LinksCmp(Props) {
  var links = Props.links;
  var container_class = Props.container_class;
  var child_class = Props.child_class;
  var on_clickOpt = Props.on_click;
  var on_click = on_clickOpt !== undefined ? on_clickOpt : (function (param) {
        
      });
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  return React.createElement("nav", {
              className: container_class,
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(PageviewStore$PorterinFeature.ga_header_event_prefix, HomeStoreEn$PorterinFeature.ga_header_link_action, citySelectedContext.category);
                })
            }, links.map(function (link, index) {
                  return React.createElement(Link, {
                              href: link.link,
                              children: React.createElement("div", {
                                    key: String(index),
                                    className: child_class,
                                    onClick: (function (param) {
                                        Curry._1(on_click, undefined);
                                        PublishEventsHelper$PorterinFeature.publishEvents(PageviewStore$PorterinFeature.ga_header_event_prefix, HomeStoreEn$PorterinFeature.ga_header_specific_link_action, link.label);
                                      })
                                  }, link.label)
                            });
                }));
}

var Link$1;

var make = LinksCmp;

export {
  Link$1 as Link,
  make ,
}
/* react Not a pure module */
